export { default as adminVars } from "./admin.json";
export { default as clientVars } from "./client.json";
export * from "./roles";

export const dateFormat = "YYYY-MM-DD h:mm:ss a";
export const ssoUrl = process.env.REACT_APP_SSO_URL;
export const appsPageUrl = process.env.REACT_APP_APPS_PAGE_URL;
export const cookiesDomain = process.env.REACT_APP_COOKIES_DOMAIN;
export const livePayTool = "LIVE_PAY_BENCHMARKING_TOOL";
